module.exports = __webpack_public_path__ + "img/shfs.0b6349ff.svg";